import { Country } from '~/Api/Country';

export enum ErrorCode {
	requiredProductSettingsMissing = 'slovenia-max-price-calculation-required-product-settings-is-missing',
	requiresMinOneEuropeanProduct = 'slovenia-max-price-calculation-requires-at-least-one-european-country-product',
	requiresMaxOneEuropeanProduct = 'slovenia-max-price-calculation-requires-at-most-one-product-per-european-country',
	requiresReferenceSettings = 'slovenia-max-price-calculation-requires-reference-settings',
	cannotChangeSettingsForNonMemberProducts = 'slovenia-max-price-calculation-cannot-change-settings-for-non-member-products',
	illegalPriceTypeSelected = 'slovenia-max-price-illegal-price-type-selected',
	exportB1RequiresReferenceCountries = 'slovenia-max-price-export-b1-requires-reference-countries',
}

export class Error {
	code: ErrorCode;

	productId: string | null;

	duplicateCountries: Country[];

	constructor(code: ErrorCode, productId: string | null, duplicateCountries: Country[]) {
		this.code = code;
		this.productId = productId;
		this.duplicateCountries = duplicateCountries;
	}
}
